import React, { useCallback, useRef, useState } from 'react';

import Sidebar from 'components/Navbars/Sidebar';
import Header from 'components/Navbars/Admin/AdminNavbar';
import { Outlet } from 'react-router-dom';
import ContentHeightContext from 'contexts/ContentHeightContext';
import useResizeObserver from '@react-hook/resize-observer';
import AlertProvider from 'contexts/AlertProvider';

function Dashboard() {

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);

  const target = useRef<HTMLDivElement>(null);
  useResizeObserver(target, (entry) => setContentHeight(entry.contentRect.height))

  return (
    <div className="flex min-h-screen">

      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1" ref={target}>

        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main className='grow bg-slate-100'>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <AlertProvider>
              <ContentHeightContext.Provider value={{height: contentHeight}}>
                <Outlet></Outlet>
              </ContentHeightContext.Provider>
            </AlertProvider>
          </div>
        </main>

      </div>
    </div>
  );
}

export default Dashboard;